import { client, gql } from './Client';

const environmentConditionsQuery = gql`
  query allEnvironmentConditions {
    allEnvironmentConditions {
      pkEnvironmentConditionCategory
      name
      abbrv
      isActive
      siteLayer
      dateCreated
      description
      environmentCondition {
        pkEnvironmentCondition
        name
      }
    }
  }
`;

const environmentConditions = () => client.query({ query: environmentConditionsQuery });

export { environmentConditions };
